import React from "react";
import { Container, Row, Col, Form, Input, Button } from "reactstrap";
import Select from "react-select";

const AdmissionDashboard = () => {
  return (
    <Container>
      <h3 className="m-auto text-center">Admission Dashboard</h3>

      <Row>
        <Col lg="5" md="6" sm="12"></Col>

        <Col lg="5" md="6" sm="12"></Col>
      </Row>

      {/* Add more rows and columns for additional content */}
    </Container>
  );
};

export default AdmissionDashboard;
